export default __webpack_public_path__ + "static/media/Aakash's Resume (5).1e0a5f1b.pdf";